import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { getJobCandidateAIMatchScores, IJob } from 'wisestep-api';
import { WsBadge, WsBadgeSize, WsBadgetype, WsColors } from 'wisestep-base';

import { warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

interface AiMatchScoreButtonProps {
  job: IJob;
  email: string;
  linkedInUrl: string;
}

export const StyledAIMatchButton = styled(Button)(() => ({
  fontSize: 14,
  backgroundColor: 'transparent',
  color: WsColors.TheBlues750,
  '&.Mui-disabled': {
    backgroundColor: 'transparent',
    color: WsColors.TheBlues750,
    pointerEvents: 'none',
  },
  '&:hover': {
    backgroundColor: 'transparent',
    color: WsColors.TheBlues750,
  },
}));

const AiMatchScoreButton: React.FC<AiMatchScoreButtonProps> = ({ job, email, linkedInUrl }) => {
  const [load, setLoad] = useState<boolean>(false);
  const [score, setScore] = useState<number>(-1);
  const setNotificationStore = useNotificationStore((state) => state.setNotification);
  const handleAIMatchScore = async () => {
    setLoad(true);
    try {
      const res = await getJobCandidateAIMatchScores([
        {
          email,
          linkedInUrl,
          jobMatchingContent: [job?.title ?? '', job?.description ?? ''],
          jobSkills: job?.skills ?? [],
          jobTitle: job?.title ?? '',
        },
      ]);

      if (res?.data?.length) {
        setScore(res?.data?.[0].aiMatchScore);
      } else {
        setScore(0);
      }
    } catch (e) {
      console.error(e);
      setNotificationStore(warning('SomeThing Went wrong'));
    } finally {
      setLoad(false);
    }
  };
  if (score === -1) {
    return (
      <StyledAIMatchButton
        variant="text"
        onClick={handleAIMatchScore}
        disabled={load}
        endIcon={load ? <CircularProgress size={20} /> : <></>}
      >
        Check AI Match score
      </StyledAIMatchButton>
    );
  }

  return (
    <WsBadge
      label={`AI Match: ${score}%`}
      badgeSize={WsBadgeSize.LARGE}
      badgeType={WsBadgetype.SUCCESS}
    />
  );
};

export default AiMatchScoreButton;
